'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import {
  AUTH_HOME_PATH,
  AUTH_REQUIRED_QUERY_PARAM,
  AUTH_REQUIRED_QUERY_VALUE,
} from '@/config/auth-routes';
import RootHeader, { type RootHeaderProps } from './root-header';

export function SiteHeaderContent(props: RootHeaderProps) {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  // Preserve the standalone sign-in screen used by protected-route redirects.
  if (
    !props.isLoggedIn &&
    pathname === AUTH_HOME_PATH &&
    searchParams.get(AUTH_REQUIRED_QUERY_PARAM) === AUTH_REQUIRED_QUERY_VALUE
  ) {
    return null;
  }

  return <RootHeader {...props} />;
}
